export default __webpack_public_path__ + "static/media/32.f47e61cf.png";